export const onFullDownloadSubscription = `subscription onFullDownload($adminEmployeeId: String!, $committeeId: String!, $datetimeId: String!) {
    onFullDownload(adminEmployeeId: $adminEmployeeId, committeeId: $committeeId, datetimeId: $datetimeId) {
        adminEmployeeId
        committeeId
        datetimeId
        filename
        rawText
    }
}`;